import React, { useEffect } from 'react';
import './OnboardingBasePage.scss';
import useNavigate from 'Hooks/useNavigate';
import BackIcon from '_assets/img/icons/back-icon.svg';

interface OnboardingBasePageProps {
    header?: string;
    subtitle?: string;
    children: React.ReactNode;
    className?: string;
    showBackButton?: boolean;
}

const OnboardingBasePage: React.FC<OnboardingBasePageProps> = ({
    header,
    children,
    className,
    showBackButton,
}) => {
    const navigate = useNavigate();

    /** disable scrolling on body, as set by app.tsx. Reset by BaseLayout.tsx    */
    useEffect(() => {
        document.body.classList.add('full-screen');
    }, []);

    return (
        <div className={`onboarding-base-page ${className ?? ''}`}>
            {showBackButton && (
                <div
                    className="onboarding-base-page__back-button"
                    onClick={() => navigate(-1)}
                >
                    <img src={BackIcon} alt="back" />
                </div>
            )}
            {header && (
                <div className="onboarding-base-page__header">{header}</div>
            )}
            <div className="onboarding-base-page__content">{children}</div>
        </div>
    );
};

export default OnboardingBasePage;
